import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import UserTestimonyCard from '../../components/cards/UserTestimonyCard';
import BasicHero from '../../components/BasicHero';
import { PATHS } from '../../utils/urls';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="page-integrations" ontouchstart>
            <SEO title="Customers | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="ChartHop is proud to partner with some of the best companies in the world. See how organizations like InVision, BetterCloud and MongoDB are using ChartHop today."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Customers | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="ChartHop is proud to partner with some of the best companies in the world. See how organizations like InVision, BetterCloud and MongoDB are using ChartHop today." />
                <meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Customers | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="ChartHop is proud to partner with some of the best companies in the world. See how organizations like InVision, BetterCloud and MongoDB are using ChartHop today." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HERO CONTENT */}
            <section className="sectionSpacing">
                <div className="col-md-12 text-center">
                    <img src='/home/bunny.svg' alt="" />
                    <BasicHero title="Our Hoppy Customers" subtitle="We're proud to partner with some of the best companies in the world." />
                </div>
            </section>

            <section className="customer testimonial-container">
                <div className="container pt-2 pb-5 pb-md-10">
                    <div className="row align-items-center">

                        <div className="d-flex flex-wrap justify-content-center customer-logos-2">
                            <img src='/home/brand_logos/mongodb-logo.svg' alt="MongoDB" className="" />
                            <img src='/home/brand_logos/starburst-logo_black.svg' alt="Starbust" className="" />
                            <img src='/home/brand_logos/bettercloud-logo.svg' alt="bettercloud" className="" />
                            <img src='/home/brand_logos/invision-logo.svg' alt="Invision" className="" />
                            <img src='/home/brand_logos/remy-logo.svg' alt="Remy" className="" />
                            <img src='/home/brand_logos/postman-logo-black.svg' alt="Postman" className="" />
                            <img src='/home/brand_logos/lightspeed-logo-black.svg' alt="lightspeed" className="smallSVG" width="99" />
                            <img src='/home/brand_logos/assurance-logo.svg' alt="Assurance" className="" />
                            <img src='/home/brand_logos/sequoia-logo.svg' alt="sequoia" className="" />
                            <img src='/home/brand_logos/plaid-logo.svg' alt="plaid" className="" />
                        </div>
                    </div>
                </div>
            </section >

            {/* ROI section */}


            <section className="sectionSpacing flex-centeredColumn  backgroundGradientContainer">
                <div className="roi-div-block1">
                    <h2 className="text-center mt-0  sectionSpacing-Margin ">ChartHop increases the ROI of your most important investment <strong>- your people.</strong></h2>
                    <p className="text-center my-2 indent-p">This impact is felt across the organization, both in the day-to-day operations and in the execution of the company’s most important, strategic decisions. </p>
                </div><br />
                <h4 className="text-center mt-0 sectionSpacing-Margin">ChartHop Customers see increases in:</h4>
                <div className="flex-centeredColumn contentBlock">
                    <div className="flex-platform svg-info2-roi">
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/productivity.svg '} alt="" />
                            <p className="p-roi">Productivity</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/aligment.svg'} alt="" />
                            <p className="p-roi">Alignment</p>
                        </div>
                        <div className="svg-info-card-3col2 people-width">
                            <img src={'/product/org-chart/clarity.svg'} alt="" />
                            <p className="p-roi">Clarity</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/belonging.svg'} alt="" />
                            <p className="p-roi">Belonging</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/agility.svg'} alt="" />
                            <p className="p-roi">Agility</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/conﬁdence.svg'} alt="" />
                            <p className="p-roi">Confidence</p>
                        </div>
                    </div>
                </div><br /><br />

                {/*<p className="text-center p-headerCustomers ">resulting in</p>*/}
                <div className="beetweenlines contentBlock">
                    <p className="text-center p-headerCustomers p-beetweenlines">resulting in</p>
                </div>


                <section className="sectionSpacing flex-centeredColumn roi-bullets-section">
                    <div className="contentBlock">
                        <div className="flex-centeredColumn contentBlock">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Better strategy</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Faster execution</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Time savings</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Cost reductions</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </section><br />


            {/*Testimony section */}
            <section className="text-left flex-centeredColumn sectionSpacing padding-section" id="Customer Stories">
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer ">

                <div className="backgroundGradientContainer">
                        <UserTestimonyCard
                            testimony={<p>
                                "There's that old saying that a picture is worth a thousand words.
                                That’s where ChartHop comes into play. <br /> <br />
                                <strong>With rich visuals, you can understand and see things so much faster than trying to figure things out through spreadsheets.</strong><br /><br />
                                Now, Headcount Planning takes me almost no time at all because really I'm not doing the work. It’s the team leads who are really thinking about what their teams need.<br /><br />
                                Rather than me dictating headcounts for each team, I'd rather them tell me what they need. <strong>And ChartHop is the perfect tool to foster that two-way communication."</strong>
                            </p>}
                            logo="/customers/customer-stories/logos/png/starburst.png"
                            name="Justin Borgman"
                            readMoreButton={true}
                            readMoreLink={PATHS.BLOG_BEST_PRACTICES_STARBUST}
                            readMoreText="how Starburst used ChartHop to fuel their hypergrowth"
                            position="CEO"
                            image="/customers/customer-stories/thumbnails/Justin-Borgman.png"
                            imbalanced={true}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "With a fully-distributed growing team, it can be challenging to understand how our organization has evolved and how teams are structured. Thanks to ChartHop's auto-updated org chart, we can easily find our coworkers and reach out to them seamlessly via email or Slack. <br /> <br />
                                Being able to visualize the org chart by any dimension (department, time, zone, gender, squad) has <strong> empowered</strong> my team to make more
                                <strong> strategic people decisions</strong>. Plus, the org chart being fully integrated with our HRIS makes for seamless updates and
                                <strong> zero manual work</strong> for my team. <br /> <br />
                                Now, all of our employees can login to ChartHop and see the org structure, how the team is growing and even where their coworkers are on the map.  <br /> <br />
                                ChartHop hasn't just been more convenient and efficient, it's also<strong> saved the company the equivalent of $2.5M in lost productivity</strong> across the organization."
                            </p>}
                            logo="/resources/customer-stories/invision-logo.png"
                            name="Shelby Wolpa"
                            readMoreButton={true}
                            readMoreLink={PATHS.INVISION_STORY}
                            readMoreText="managing a global, fully distributed, workforce"
                            position="VICE PRESIDENT OF PEOPLE OPERATIONS"
                            image="/customers/customer-stories/thumbnails/shelby-wolpa@2x.png"
                            imbalanced={false}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "I value ChartHop so much as a People leader. The system is <strong> comprehensive, the UI is intuitive and the workflow is clean and logical.</strong>
                                <br /><br /> I'm very excited to finally have a system in place that supports <strong>data-driven headcount planning </strong> decisions. <br /><br />Unlike many other HR systems, there is no selling required to yield internal adoption. Once my business owners were provided access and given a tour of the dashboards we built for them, they were hooked."
                            </p>}
                            logo="/customers/customer-stories/logos/png/even.png"
                            name="Kyle Roberts"
                            readMoreButton={true}
                            readMoreLink={PATHS.EVEN_STORY}
                            readMoreText="empowering data-driven business decisions"
                            position="CHIEF PEOPLE OFFICER"
                            image="/customers/even/kyle-roberts_even-th.jpg"
                            imbalanced={true}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "ChartHop allows me to focus on important projects like recruiting, workforce planning, and internal trainings. <strong>It just allows me to do my job.</strong>
                                <br></br> <br></br>

                                The platform is user friendly, interactive and one of best tools I have ever used in my career!"
                            </p>}
                            logo="/customers/customer-stories/logos/png/remy-cointreau.png"
                            name="Joe Taranto"
                            readMoreButton={true}
                            readMoreLink={PATHS.REMY_STORY}
                            readMoreText="how Rémy Cointreau unleashed HR’s strategic power"
                            position="HR GENERALIST & PROJECT MANAGER"
                            image="/customers/remy/joe-taranto.jpg"
                            imbalanced={false}
                        />
                    </div>


                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                “With ChartHop, I feel like I’ve got this superpower added to my arsenal that is letting me really lead the company and talk about how this will positively impact us and allow us to meet our goals this year with everybody involved.”
                            </p>}
                            logo="/customers/show/showbie.png"
                            name="Colin Bramm"
                            readMoreButton={true}
                            readMoreLink={PATHS.SHOWBIE_STORY}
                            readMoreText="navigating post-Series A growth"
                            position="CEO & Co-Founder @ Showbie"
                            image="/customers/show/colin-bramm-showbie.jpg"
                            imbalanced={true}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "ChartHop is the <strong>perfect</strong> product for companies in a world where remote work is the standard, where building diverse teams is critical and being agile as a business is the only way to thrive."
                            </p>}
                            logo="/customers/customer-stories/logos/png/bettercloud-logo.png"
                            name="David Politis"
                            readMoreButton={false}
                            readMoreLink=""
                            readMoreText="case studies"
                            position="CEO"
                            image="/home/quotes/DavidPolitis_BetterCloud.jpeg"
                            imbalanced={false}
                        />
                    </div>





                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "ChartHop allows us to do <strong>strategic planning</strong> anytime we want instead of just once a year. Having an <strong>accurate,
                                    single source of employee data</strong> is a game changer and empowers <strong>better management decisions</strong> and employee transparency. <br /> <br />
                                ChartHop <strong>reduces the operational hurdle</strong> of the dreaded annual planning process and allows managers to <strong>access accurate people data</strong> any time they want. This has allowed us to
                                make more <strong>thoughtful personnel decisions</strong> throughout the year and provided increased transparency to all of our employees."
                            </p>}
                            logo="/customers/customer-stories/logos/png/closeriq.png"
                            name="Jordan Wan"
                            readMoreButton={false}
                            readMoreLink=""
                            readMoreText="case studies"
                            position="CEO"
                            image="/supporters/jordan-wan-new.jpg"
                            imbalanced={true}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                “Our organization is always changing! People can't keep up with who is who and or who to go to for what. We needed an org chart to visualize the org, especially as we onboard new people.<br /> <br />
                                Before ChartHop, building an org chart would have taken me 20 hours upfront and at least three hours every week to clean up. The process was infuriating.<br /> <br />
                                ChartHop is amazing. There's no org chart software that’s so easy to set up and boom! It's done. ChartHop has <strong>saved me SO much time</strong>."
                            </p>}
                            logo="/customers/customer-stories/logos/png/assurance.png"
                            name="Anthony Rotoli"
                            readMoreButton={false}
                            readMoreLink=""
                            readMoreText="case studies"
                            position="HEAD OF TALENT"
                            image="/customers/customer-stories/thumbnails/Anthony Rotoli@2x.png"
                            imbalanced={false}
                        />
                    </div>

                    <div className="backgroundGradientContainer margin-cards">
                        <UserTestimonyCard
                            testimony={<p>
                                "ChartHop helped us replace our <strong>mundane, outdated processes</strong>. <br /> <br />
                                With the auto-updated org chart, custom reporting, and real-time scenario-building, ChartHop has been a critical tool in my organization's <strong>succession planning</strong> and <strong>data comprehension</strong>. <br /> <br />
                                Now I can blueprint my organizational changes and understand budget impact - <strong>all in one place</strong> <br /> <br />
                                ChartHop will help you more <strong>efficiently</strong> look at and <strong>analyze</strong> your organization. I can't imagine what we'd do without it."
                            </p>}
                            logo="/customers/customer-stories/logos/png/remy-cointreau.png"
                            name="David Dankenbrink"
                            readMoreButton={false}
                            readMoreLink=""
                            readMoreText="case studies"
                            position="VICE PRESIDENT, HUMAN RESOURCES"
                            image="/customers/customer-stories/thumbnails/david-dankenbrink@2x.png"
                            imbalanced={true}
                        />
                    </div>

                </div>
            </section>


            {/* Everything you need*/}
            <section className="sectionSpacing flex-centeredColumn backgroundGradientContainer padding-section">
                <h2 className="text-center mt-0 sectionSpacing-Margin ">Everything you need in one platform.</h2>

                <div className="flex-centeredColumn contentBlock">
                    <div className="flex-platform svg-info2-everything">
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/data-centralization.svg '} alt="Visualize" />
                            <p className="">Data Centralization</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/visualize.svg'} alt="Put a face to the name" />
                            <p className="">Org Chart & Employee Profiles</p>
                        </div>
                        <div className="svg-info-card-3col2 ">
                            <img src={'/product/org-chart/people-analytics.svg'} alt="Time Saving" />
                            <p className="">People Analytics</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/compensation.svg'} alt="Transparency" />
                            <p className="">Compensation & Headcount Planning</p>
                        </div>
                        <div className="svg-info-card-3col2">
                            <img src={'/product/org-chart/performance.svg'} alt="Work" />
                            <p className="">Performance Reviews</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* LONG FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-customers-demo-bottom"} headertext={HtmlParser("<h2> See what everyone's talking about.</h2><h2>Let's chat!</h2>")} />
            </section>
        </Layout>
    );
};


export default Home;
